import { Mail, Phone, MapPin, Facebook, Linkedin, Twitter, Instagram } from 'lucide-react';

const FooterEn = () => {
  const navigationLinks = [{
    name: 'Home',
    href: '/en/'
  }, {
    name: 'Startup Journey',
    href: '/en/startup-journey'
  }, {
    name: 'Reports',
    href: '/en/reports'
  }];

  const sectorViewLinks = [{
    name: 'Startups',
    href: '/en/startups'
  }, {
    name: 'Scale-ups',
    href: '/en/scaleups'
  }];

  const thinkTankLinks = [{
    name: 'What we do',
    href: '/en/insightlab/what-we-do'
  }, {
    name: 'Consultation',
    href: '/en/insightlab/consultation'
  }, {
    name: 'Research',
    href: '/en/insightlab/research'
  }, {
    name: 'Contribute',
    href: '/en/insightlab/contribute'
  }, {
    name: 'Calendar',
    href: '/en/calendar'
  }];

  const aboutLinks = [{
    name: 'About SSN',
    href: '/en/about'
  }, {
    name: 'News & Press',
    href: '/en/newsroom'
  }, {
    name: 'Partners',
    href: '/en/partners'
  }];

  const legalLinks = [{
    name: 'Terms of Use',
    href: '/en/terms'
  }, {
    name: 'Privacy Policy',
    href: '/en/privacy'
  }, {
    name: 'Cookie Policy',
    href: '/en/cookies'
  }, {
    name: 'Accessibility',
    href: '/en/accessibility'
  }];

  const socialLinks = [{
    icon: Facebook,
    href: '#',
    label: 'Facebook'
  }, {
    icon: Linkedin,
    href: '#',
    label: 'LinkedIn'
  }, {
    icon: Twitter,
    href: '#',
    label: 'Twitter'
  }, {
    icon: Instagram,
    href: '#',
    label: 'Instagram'
  }];

  return (
    <footer className="text-white" style={{ backgroundColor: 'hsl(var(--brand-deep-blue))' }}>
      <div className="container mx-auto px-6 py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8 mb-12">
          {/* Contact Information - Takes 2 columns on large screens */}
          <div className="lg:col-span-2">
            <h3 className="text-white font-bold text-lg mb-6">Contact Information</h3>

            <div className="space-y-4 mb-8">
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-cyan-400" />
                <a
                  href="mailto:contact@swedenstartupnation.se"
                  className="text-gray-300 hover:text-[#0066cc] transition-colors text-sm"
                >
                  contact@swedenstartupnation.se
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-cyan-400" />
                <a
                  href="tel:+46123456789"
                  className="text-gray-300 hover:text-[#0066cc] transition-colors text-sm"
                >
                  +46 123 456 789
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 mt-1 flex-shrink-0 text-cyan-400" />
                <div className="text-gray-300 text-sm">
                  <p>Combient Zenit</p>
                  <p>Vasagatan 12</p>
                  <p>111 20 Stockholm, Sweden</p>
                </div>
              </div>
            </div>

            {/* Social Links */}
            <div>
              <h4 className="text-white font-semibold mb-4">Follow Us</h4>
              <div className="flex space-x-3">
                {socialLinks.map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    className="w-10 h-10 bg-gray-700 rounded-lg flex items-center justify-center text-gray-400 hover:bg-[#0066cc] hover:text-[#030e30] transition-all duration-200"
                    aria-label={social.label}
                  >
                    <social.icon className="w-5 h-5" />
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Navigation Links */}
          <div>
            <h3 className="text-white font-semibold mb-6">Navigation</h3>
            <ul className="space-y-3">
              {navigationLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-300 hover:text-[#0066cc] transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Sector View */}
          <div>
            <h3 className="text-white font-semibold mb-6">Sector View</h3>
            <ul className="space-y-3">
              {sectorViewLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-300 hover:text-[#0066cc] transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Think Tank */}
          <div>
            <h3 className="text-white font-semibold mb-6">Think Tank</h3>
            <ul className="space-y-3">
              {thinkTankLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-300 hover:text-[#0066cc] transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* About */}
          <div>
            <h3 className="text-white font-semibold mb-6">About</h3>
            <ul className="space-y-3">
              {aboutLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-300 hover:text-[#0066cc] transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal & Policies */}
          <div>
            <h3 className="text-white font-semibold mb-6">Legal & Policies</h3>
            <ul className="space-y-3">
              {legalLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-300 hover:text-[#0066cc] transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom section with copyright */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © 2025 Sweden Startup Nation. All rights reserved.
            </p>
            <p className="text-gray-500 text-xs">
              All displayed data is sourced from our trusted, verified database. Where third-party data is referenced, sources are clearly indicated alongside the information.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterEn;
